import * as React from 'react'
import {Box} from "@mui/material";
import {formatProductsUnits} from "@ui-seeker/utils";


export default function sellersColumn() {
    return {
        name: 'numSellers', label: 'Nº Sellers',
        options: {
            customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                {formatProductsUnits(value)}
            </Box>
        }
    }
}